import ITuneSelectorService from "../interfaces/tune_selector_service";
import { injectable } from "inversify";
import SelectedDance from "@/model/selected_dance";

@injectable()
export default class TuneSelectorService implements ITuneSelectorService
{
	constructor()
	{
	}

	public copyTracksToFirstGroup(
		tracks: Array<SelectedDance>,
		audioGroup1: Array<SelectedDance>,
		audioGroup2: Array<SelectedDance>,
		audioGroup3: Array<SelectedDance>): Array<SelectedDance>
	{
		audioGroup2.length = 0;
		audioGroup3.length = 0;
		audioGroup1.length = 0;
		audioGroup1.push(...tracks);

		return audioGroup1;
	}

	public copyTracksToSecondGroup(
		tracks: Array<SelectedDance>, 
		audioGroup2: Array<SelectedDance>,
		audioGroup3: Array<SelectedDance>): Array<SelectedDance>
	{
		audioGroup2.length = 0;
		audioGroup3.length = 0;
		audioGroup2.push(...tracks);

		return audioGroup2;
	}

	public copyTracksToThirdGroup(
		tracks: Array<SelectedDance>, 
		audioGroup3: Array<SelectedDance>): Array<SelectedDance>
	{
		audioGroup3.length = 0;
		audioGroup3.push(...tracks);

		return audioGroup3;
	}
}
